module.exports = __webpack_public_path__ + "static/media/ah30.48e8fc00.jpg";